import { SoundEvent } from "../../sound/sound-events";
import SoundManager from "../../sound/sound-manager";

export function PlaySymbolSoundCommand(symbolType: string, matches: string, currentCycle: string) {
    SoundManager.event(SoundEvent.symbol_ID_win, symbolType);
    SoundManager.event(SoundEvent.symbol_ID_win_CYCLE, symbolType, currentCycle);
    SoundManager.event(SoundEvent.symbol_ID_MATCHES_win, symbolType, matches);
    SoundManager.event(SoundEvent.symbol_ID_win_MATCHES_CYCLE, symbolType, matches, currentCycle);
    SoundManager.event(SoundEvent.symbol_any_win);
    SoundManager.event(SoundEvent.symbol_any_win_CYCLE, currentCycle);
    SoundManager.event(SoundEvent.symbol_any_MATCHES_win, matches);
    SoundManager.event(SoundEvent.symbol_any_win_MATCHES_CYCLE, matches, currentCycle);
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/symbols/play-symbol-sound-command.ts